import React from 'react';
import { MedalBronzeIcon, MedalGoldIcon, MedalSilverIcon, StarAltIcon } from 'icons';

import { useStyles } from './styles';

interface PowerProps {
  power: number;
  exclusive: boolean;
}

const Power = ({ power, exclusive }: PowerProps) => {
  const { classes, cx } = useStyles();

  let content = null;

  switch (power) {
    case 6:
      content = <MedalBronzeIcon />;
      break;
    case 7:
      content = <MedalSilverIcon />;
      break;
    case 8:
      content = <MedalGoldIcon />;
      break;
    default:
      content = [...Array(power)].map((_, i) => <StarAltIcon key={i} />);
      break;
  }

  return (
    <div
      className={cx(classes.power, {
        [classes.powerExclusive]: exclusive,
      })}
    >
      {content}
    </div>
  );
};

export default Power;
